import { render, staticRenderFns } from "./EventGroup.vue?vue&type=template&id=5fe750ca&"
import script from "./EventGroup.vue?vue&type=script&lang=js&"
export * from "./EventGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports